// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_hm","advertCardNum":"c-a_hn"};